<template>
  <v-container fluid class="pa-0">
    <AuthorsTable />
  </v-container>
</template>

<script>
import AuthorsTable from '@/components/references/AuthorsTable.vue'

export default {
  name: 'AuthorsManagement',
  components: {
    AuthorsTable
  }
}
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
  font-weight: 500;
}
</style>